import React, { useState } from "react";
import _ from "lodash";
import Dialog from "../Dialog";

const TableViewWrapTextInDialog = ({ text, length }) => {
    const [stateObj, setStateObj] = useState({
        showDialog: false
    });

    return (
        <>
            <span
                style={{ cursor: "pointer",fontStyle:"italic" }}
                onClick={() => setStateObj(prev => ({ ...prev, showDialog: true }))}
            >
                {_.truncate(text, { length })}
            </span>
            {stateObj.showDialog &&
                <Dialog
                    width="40%"
                    open={true}
                    contentText={text}
                    showDialogTitle={false}
                    showDialogAction={true}
                    showAcceptBtn={false}
                    maxWidth={false}
                    onClose={() =>
                        setStateObj(prev => ({
                            ...prev,
                            showDialog: false,
                        }))
                    }
                />
            }
        </>
    )
}

export default TableViewWrapTextInDialog;